module.exports = __webpack_public_path__ + "img/IR_.5200d6e.jpg";